var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"boeder"},[_vm._v("aaa")]),_c('div',{staticClass:"boeder"},[_vm._v("bbb")])])
}]

export { render, staticRenderFns }